"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionCancels = void 0;
var utils_1 = require("../../utils");
exports.optionCancels = function (axios) {
    return {
        /** @deprecated postOptionCancelsV2 사용해주세요 */
        postOptionCancels: function (request) {
            return axios.post('/option-cancels', request.data);
        },
        // 옵션취소 신청
        postOptionCancelsV2: function (request) {
            return axios.post('/option-cancels', request.data);
        },
        /** @deprecated postOptionCancelsPredictV2 사용해주세요 */
        postOptionCancelsPredict: function (request) {
            return axios.post('/option-cancels/predict', request.data);
        },
        // 옵션취소 예상금액을 계산
        postOptionCancelsPredictV2: function (request) {
            return axios.post('/option-cancels/predict', request.data);
        },
        // 품절취소처리
        postOptionCancelsSoldOut: function (request) {
            return axios.post('/option-cancels/sold-out', request.data);
        },
        // 옵션취소 수정
        putOptionCancelsNo: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}', request);
            return axios.put(url, request.data);
        },
        // 세트옵션 품절취소처리
        postOptionCancelsSoldOutSetOption: function (request) {
            return axios.post('/option-cancels/sold-out/set-option', request.data);
        },
        // 이미출고
        putOptionCancelsNoAlreadyDelivery: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/already-delivery', request);
            return axios.put(url, request.data);
        },
        // 옵션취소 승인
        putOptionCancelsNoApprove: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/approve', request);
            return axios.put(url);
        },
        // 취소 현금 환불처리
        putOptionCancelsNoCashRefund: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/cash-refund', request);
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put(url, request.data, config);
        },
        // 옵션취소 이미 출고 가능 여부 체크
        getOptionCancelsNoCheckAlreadyDelivery: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/check-already-delivery', request);
            return axios.get(url);
        },
        /** @deprecated postOptionCancelsNoPredictV2 사용해주세요 */
        postOptionCancelsNoPredict: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/predict', request);
            return axios.post(url, request.data);
        },
        // 옵션취소 수정 전 예상금액을 계산
        postOptionCancelsNoPredictV2: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/predict', request);
            return axios.post(url, request.data);
        },
        // 옵션취소 철회
        putOptionCancelsNoWithdraw: function (request) {
            var url = utils_1.paramPathchange('/option-cancels/{no}/withdraw', request);
            return axios.put(url);
        }
    };
};
